import React from "react";

function ScheduleTable({ setScheduleSelected, scheduleSelectedData }) {
  console.log("scheduleSelectedData", scheduleSelectedData);
  return (
    <div className="_orderScheduleSearchResultTableBody">
      <h5 onClick={() => setScheduleSelected(false)}>Back to Schedule</h5>
      <div className="_orderScheduleSearchTableParent">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 col-12">
              <table>
                <tbody>
                  <tr>
                    <th>Origin Country</th>
                    <th>:</th>
                    <td>Origin</td>
                  </tr>
                  <tr>
                    <th>Destination Country</th>
                    <th>:</th>
                    <td>Destination</td>
                  </tr>
                  <tr>
                    <th>Sending Agent</th>
                    <th>:</th>
                    <td>Sending</td>
                  </tr>
                  <tr>
                    <th>Vessel</th>
                    <th>:</th>
                    <td>Vessel</td>
                  </tr>
                  <tr>
                    <th>Departure Date</th>
                    <th>:</th>
                    <td>06-01-2022</td>
                  </tr>
                  <tr>
                    <th>Cut-Off Date</th>
                    <th>:</th>
                    <td>06-01-2022</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-6 col-12">
              <table>
                <tbody>
                  <tr>
                    <th>Origin Port</th>
                    <th>:</th>
                    <td>Origin</td>
                  </tr>
                  <tr>
                    <th>Destination Port</th>
                    <th>:</th>
                    <td>Destination</td>
                  </tr>
                  <tr>
                    <th>Recieving Agent</th>
                    <th>:</th>
                    <td>Recieving</td>
                  </tr>
                  <tr>
                    <th>Voyage</th>
                    <th>:</th>
                    <td>Voyage</td>
                  </tr>
                  <tr>
                    <th>Arrival Date</th>
                    <th>:</th>
                    <td>06-01-2022</td>
                  </tr>
                  <tr>
                    <th>Carrier</th>
                    <th>:</th>
                    <td>Carrier</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleTable;
